/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import { useDataProvider } from 'react-admin';

export const useApplication = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const dataProvider = useDataProvider();
  useEffect(() => {
    setLoading(true);
    dataProvider
      .getOne('application', { id: 'pwa' })
      .then(({ data }) => {
        setData(data);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setError(error);
        setLoading(false);
      });
  }, [dataProvider]);

  return {
    data, loading, error, setData,
  };
};

export const usePopulateOffer = ({ offer }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const dataProvider = useDataProvider();
  useEffect(() => {
    if (offer) {
      setLoading(true);
      dataProvider
        .getOne('offer', {
          id: offer,
        })
        .then(({ data }) => {
          setData(data);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setError(error);
          setLoading(false);
        });
    }
  }, [dataProvider, offer]);

  return {
    data, loading, error, setData,
  };
};

export const usePopulateProducts = ({ products }) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const dataProvider = useDataProvider();
  useEffect(() => {
    if (products) {
      setLoading(true);
      dataProvider
        .getMany('products', {
          ids: products,
        })
        .then(({ data }) => {
          setData(data);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setError(error);
          setLoading(false);
        });
    }
  }, [dataProvider, products]);

  return {
    data, loading, error, setData,
  };
};

export const usePopulateProduct = ({ id, product }) => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const dataProvider = useDataProvider();
  useEffect(() => {
    if (product) {
      setLoading(true);
      dataProvider
        .getOne('products', {
          id: product,
        })
        .then(({ data }) => {
          setData(data);
          setLoading(false);
        })
        .catch((error) => {
          setError(error);
          setLoading(false);
        });
    }
    // eslint-disable-next-line
  }, [product]);

  return {
    data, loading, error, setData,
  };
};
